import React from 'react';
import FilterBody from './FilterBody';
import FilterHeader from './FilterHeader';

const FilterWrapper = props => {
  const showBody = props.showBody;
  const wrapperClass = props.showFilter ? "" : "hide";
  const visibilityProps = ['showFilter', 'removable', 'disabled'];
  const visibilityClasses = visibilityProps.map((visibilityProp) => {
    return `cjs-filter-wrapper-${visibilityProp}-${props[visibilityProp]}`;
  }).join(" ");
  const identifierClass = `${props.additionalWrapperClass} ${visibilityClasses}`;

  return (
    <React.Fragment>
      <div
        className={ `my-2 mr-3 ${wrapperClass} ${identifierClass}` }
        ref={ props.wrapperRef }
      >
        <FilterHeader
          title={ props.title }
          value={ props.currentValue }
          filterCount={ props.filterCount }
          fixedWidth={ props.fixedHeaderWidth }
          widthClass={ props.headerWidthClass }
          showBody={ showBody }
          dropDownIcon={props.dropDownIcon }
          removable={ props.removable }
          disabled={ props.disabled }
          invalid={ props.invalid }
          disabledTooltip={ props.disabledTooltip }
          invalidTooltip={ props.invalidTooltip }
          onRemoveHandler={ props.onRemoveHandler }
          onClickHandler={ props.disabled ? null : props.showBodyToggler }
          buttonSize={ props.buttonSize }
          rounded={ props.rounded }
          suffixConstructor={ props.headerSuffixConstructor }
          filterHeaderFontStyleClass={ props.filterHeaderFontStyleClass }
          noShadow={ props.noHeaderShadow || false }
          newUx={ props.newUx || false }
        />
        <FilterBody
          parentWrapperRef={ props.wrapperRef }
          show={ showBody }
          data={ props.children }
          fixedWidth={ props.fixedBodyWidth }
          fixedWidthClass={ props.fixedBodyWidthClass }
          additionalClass={ props.bodyClass }
          showActions={ props.showActions }
          actions={ props.actions }
          actionState={ props.actionState }
          onCancelHandler={ props.onCancelHandler }
          onSubmitHandler={ props.onSubmitHandler }
          onClearHandler={ props.onClearHandler }
        />
      </div>
    </React.Fragment>
  );
};

export default FilterWrapper;
